export default __webpack_public_path__ + "static/media/eze.71139b64.jpg";